import {
  DELETE_TASKS,
  EDIT_TASK,
  FETCH_TASKS,
  receiveTasks,
  SAVE_TASK,
} from "@/components/tasks/admin/ducks/Actions"
import {
  apiDeleteTasks,
  apiEditTask,
  apiFetchTasks,
  apiSaveTask,
} from "@/components/tasks/admin/ducks/AJAX"
import receiveUpdateSuccessWithTasks from "@/components/tasks/helpers/receiveUpdateSuccessWithTasks"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const receiveTasksSuccessCB = (cb) => (resp) => {
    dispatch(receiveTasks(resp))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case SAVE_TASK:
      apiSaveTask(
        {
          taskTitle: store.getState().tasks.user.taskTitle,
          assignBy: store.getState().tasks.user.assignBy,
          assigned: store.getState().tasks.user.assigned,
          taskDueDate: store.getState().tasks.user.taskDueDate,
          taskDescription: store.getState().tasks.user.taskDescription,
        },
        receiveUpdateSuccessWithTasks(action.success),
        action.error,
      )
      return next(action)

    case EDIT_TASK:
      apiEditTask(
        {
          taskTitle: store.getState().tasks.user.taskTitle,
          taskStatus: store.getState().tasks.user.taskStatus,
          assignBy: store.getState().tasks.user.assignBy,
          assigned: store.getState().tasks.user.assigned,
          taskDueDate: store.getState().tasks.user.taskDueDate,
          taskDescription: store.getState().tasks.user.taskDescription,
          taskIds: [store.getState().tasks.user.taskId],
        },
        receiveUpdateSuccessWithTasks(action.success),
        action.error,
      )
      return next(action)

    case DELETE_TASKS:
      apiDeleteTasks(action.taskIds, receiveUpdateSuccessWithTasks(action.success), action.error)
      return next(action)

    case FETCH_TASKS:
      apiFetchTasks(receiveTasksSuccessCB(action.success), action.error)
      return next(action)

    default:
      return next(action)
  }
}
